export const UATYPE: Object = {
  label: {
    upas: 'UPA',
    utas: 'UTA',
  },
  path: {
    upas: 'summary_upas',
    utas: 'summary_utas',
  },
};
